const Settings: {
  pwa?: boolean;
} = {
  pwa: false,
};

export default Settings;
